module.exports = __webpack_public_path__ + "static/media/imgCanvasBusiness.c11c6298.svg";